import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Animate between the collapsed and expanded content heights. Respects reduced-motion preferences.
   *
   * @type {Boolean|String}
   * @default false
   */
  animated: booleanAttribute(),
  /**
   * Initial expanded state.
   *
   * @type {Boolean|String}
   * @default false
   */
  expanded: booleanAttribute(),
  /**
   * Activator label shown when expanded. Falls back to the title attribute when not set.
   *
   * @type {String}
   * @default undefined
   */
  expandedTitle: {
    type: String,
    default: undefined,
  },
  /**
   * Position of the activator relative to the collapsed or expanded content.
   *
   * @type {String}
   * @default "start"
   */
  activatorPosition: {
    type: String,
    default: "start",
    validator: (value) => ["start", "end"].includes(value),
  },
  /**
   * Heading level (1–6) for the activator. Wraps it in a heading, so assistive tech lists the title in heading navigation.
   *
   * @type {Number|String}
   * @default undefined
   * @storybook-control number
   */
  headingLevel: {
    type: [Number, String],
    default: undefined,
    validator: (value) => [1, 2, 3, 4, 5, 6].includes(Number(value)),
  },
  /**
   * Colour for the activator label and caret. Overrides --sp-comp-expandable-area-activator-color.
   *
   * @type {String}
   * @default undefined
   */
  color: {
    type: String,
    default: undefined,
  },
});
